/**
 * Created by Daniela on 01/09/2016.
 */
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import {AuthGuardService} from "./shared/services/auth-guard.service";
import {visitantesRoutes} from "./pages/visitante/visitantes-routing.module";
import {GestaoComponent} from "./pages/gestao/gestao.component";
import {gestaoRoutes} from "./pages/gestao/gestao-routing.module";
import {VisitantesComponent} from "./pages/visitante/visitantes.component";
import {ErrorPageComponent} from "./pages/error-page/error-page.component";
import {NotTenantPageComponent} from "./pages/not-tenant-page/not-tenant-page.component";

export const routes: Routes = createRoutes();
export function createRoutes(): any {
    let tenants: any[] = [];
    if (process.env.ENV === 'production') {
        tenants = ["grupoembras", "demo", "teste"];
    } else if (process.env.ENV === 'staging') {
        tenants = ["t1", "t2", "t3", "pinda", "teste"];
    } else {
        tenants = ["t1", "t2", "t3", "pinda", "teste"];
    }

    let routes: any[] = [];

    tenants.forEach(function(item: string) {
        routes.push(
            {
                path: item + '/visitante',
                component: VisitantesComponent,
                canActivate: [AuthGuardService],
                children: visitantesRoutes
            }
        );
        routes.push(
            {
                path: item,
                component: GestaoComponent,
                canActivate: [AuthGuardService],
                children: gestaoRoutes
            }
        );
    });

    routes.push(
        {
            path: '',
            component: NotTenantPageComponent
        }
    );

    routes.push(
        {
            path: '**',
            component: ErrorPageComponent
        }
    );

    return routes;
}

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app-routing.module.ts
 **/